import React from 'react'

const PageNotFound = () => {
  return (
    <>
    PageNotFound
    </>
  )
}

export default PageNotFound